// extracted by mini-css-extract-plugin
module.exports = {"suffixed":"_4EBQ0X"};